"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var utilities_1 = require("../../../utilities");
var TableLoading = function (_a) {
    var colsCount = _a.colsCount;
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var rowsPerPage = Number(searchParams.get('rowsPerPage') || 15);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.TableRow, { children: (0, jsx_runtime_1.jsx)(material_1.TableCell, __assign({ colSpan: colsCount, style: { padding: '0' } }, { children: (0, jsx_runtime_1.jsx)(material_1.LinearProgress, { variant: "query", color: "secondary" }) })) }), utilities_1.ArrayHelper.generateArray(rowsPerPage).map(function (n, rindex) { return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsx)(material_1.TableRow, { children: utilities_1.ArrayHelper.generateArray(colsCount).map(function (cindex) { return ((0, jsx_runtime_1.jsx)(material_1.TableCell, { children: (0, jsx_runtime_1.jsx)(material_1.Skeleton, { animation: "wave", variant: "text", sx: { fontSize: '1rem' } }) }, cindex)); }) }) }, rindex)); })] }));
};
exports.default = TableLoading;
